/* Progressive enhancement for the financing page: Ask Joey opens chat in place, and consent-gated GA4 clicks on the page's CTAs. The page works fully without this file. */
(() => {
  'use strict';
  if (window.wnffinInitialized) return;
  window.wnffinInitialized = true;
  const measurementId = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, {
      send_to: measurementId,
      page_location: 'https://whatsnewfurniture.com/pages/furniture-financing-portland-oregon',
      ...params
    });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const init = () => {
    if (!document.querySelector('[data-wnffin-page]')) return;
    // Capture phase, so this runs before Motion's link handler starts its page transition.
    document.addEventListener('click', (event) => {
      const cta = event.target.closest('[data-wnffin-cta]');
      if (cta) track('wnf_financing_cta_click', { cta_placement: cta.dataset.wnffinCta, transport_type: 'beacon' });
      const chat = event.target.closest('[data-wnffin-chat]');
      if (chat && typeof window.WNFChatOpen === 'function') {
        event.preventDefault();
        window.WNFChatOpen();
        track('wnf_financing_chat_open');
      }
    }, true);
    document.querySelectorAll('.wnffin details').forEach((d) => {
      d.addEventListener('toggle', () => { if (d.open) track('wnf_financing_faq_open', { question: d.querySelector('summary')?.firstChild?.textContent?.trim().slice(0, 90) }); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
